import { http } from '@/services/http'
import queryBuilder from '@/services/queryBuilder'

const pagination = [
  'total_pages',
  'next_page',
  'previous_page',
  'total_pages',
  'total_records',
  'post_per_page'
]
const trancheStructure = {
  id: true,
  amount: true,
  status: true,
  token: true,
  account: {
    email: true,
    id: true
  }
}

const getTranches = ({ state, commit }, pageNumber = 1) => {
  commit('PENDING', true)
  return new Promise((resolve, reject) => {
    const query = {
      query: queryBuilder.buildQuery({
        tranches: {
          where: {
            page: pageNumber
          },
          select: {
            page_data: trancheStructure,
            pagination: pagination
          }
        }
      })
    }

    http
      .get('/api/graphql', { params: query })
      .then((response) => {
        commit('SAVE_TRANCHES', response.data)
        resolve(response)
      })
      .catch((error) => {
        commit('PENDING', false)
        reject(error.response.data)
      })
  })
}

const findTranchesBy = ({ state, commit }, condition) => {
  commit('PENDING', true)
  return new Promise((resolve, reject) => {
    const query = {
      query: queryBuilder.buildQuery({
        tranches: {
          where: condition,
          select: {
            page_data: trancheStructure,
            pagination: pagination
          }
        }
      })
    }

    http
      .get('/api/graphql', { params: query })
      .then((response) => {
        commit('SAVE_SEARCH_TRANCHES', response.data)
        resolve(response)
      })
      .catch((error) => {
        commit('PENDING', false)
        reject(error.response.data)
      })
  })
}

const getStatuses = ({ state, commit }, condition) => {
  return new Promise((resolve, reject) => {
    const query = {
      query: queryBuilder.buildQuery({
        tranches: {
          statuses: [ 'name', 'value' ]
        }
      })
    }

    http
      .get('/api/graphql', { params: query })
      .then((response) => {
        commit('SAVE_STATUSES', response.data)
        resolve(response)
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
}

const changeTrancheStatus = ({ state, commit }, query) => {
  return new Promise((resolve, reject) => {
    http
      .post('/api/accountants/tranch_statuses', query)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
}

const getPromotorTranches = ({ state, commit }) => {
  commit('PENDING', true)
  return new Promise((resolve, reject) => {
    const query = {
      query: queryBuilder.buildQuery({
        account: {
          tranches: {
            amount: true,
            token: true,
            created_at: true,
            changes: [ 'status', 'updated_at' ]
          }
        }
      })
    }

    http
      .get('/api/graphql', { params: query })
      .then((response) => {
        commit('SAVE_TRANCHES', response.data)
        resolve(response)
      })
      .catch((error) => {
        commit('PENDING', false)
        reject(error.response.data)
      })
  })
}

export default {
  getTranches,
  getPromotorTranches,
  findTranchesBy,
  getStatuses,
  changeTrancheStatus
}



// WEBPACK FOOTER //
// ./src/store/modules/tranches/actions.js